import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faHome, 
  faHammer, 
  faBuilding, 
  faCity, 
  faTools, 
  faSun, 
  faClipboardList, 
  faHardHat 
} from '@fortawesome/free-solid-svg-icons';

// Aggiungi le icone alla libreria
library.add(
  faHome,
  faHammer,
  faBuilding,
  faCity,
  faTools,
  faSun,
  faClipboardList,
  faHardHat
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 